/** Shared CRM UI: lifecycle status pill + status option config. */
export const STATUS_CONFIG = {
  lead: { label: "Lead", className: "bg-sky-500/15 text-sky-700 dark:text-sky-300" },
  active: { label: "Active", className: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" },
  lapsed: { label: "Lapsed", className: "bg-amber-500/15 text-amber-700 dark:text-amber-300" },
  vip: { label: "VIP", className: "bg-fuchsia-500/15 text-fuchsia-700 dark:text-fuchsia-300" },
};

export const STATUS_OPTIONS = [
  { value: "lead", label: "Lead" },
  { value: "active", label: "Active" },
  { value: "lapsed", label: "Lapsed" },
  { value: "vip", label: "VIP" },
];

export const STATUS_FILTERS = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "lead", label: "Leads" },
  { value: "lapsed", label: "Lapsed" },
  { value: "vip", label: "VIP" },
];

export const StatusPill = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || { label: status, className: "bg-muted text-muted-foreground" };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide ${cfg.className}`}
      data-testid={`status-pill-${status}`}
    >
      {cfg.label}
    </span>
  );
};
